import { createUseStyles } from 'react-jss'
import { forDesktopUp } from 'src/config/mediaQueries'
import { typography } from '@dentalux/ui-library-core'
import { Theme } from '@mui/material/styles'

export default createUseStyles((theme: Theme) => ({
  root: {
    [forDesktopUp]: {
      display: 'none',
    },
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  stepName: {
    ...typography['Lato Emphasized 1'],
    color: theme.palette.primary.main,
  },
}))
